import { put, call, takeEvery } from 'typed-redux-saga';

import DashboardGateway from '~apis/dashboard';

import { store } from '~redux/store';
import combinedActions from '~redux/combinedActions';
import { ErrorMessages } from '~utils/constants';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

export default function* watchGetDashboardProductPricing(api: DashboardGateway): SagaWatcherReturnType {
    yield takeEvery('dashboard/dashboardGetDashboardProductPricingAttempt', handleGetDashboardProductPricing, api);
}

function* handleGetDashboardProductPricing(api: DashboardGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const response = yield* call([api, api.getDashboardProductPricing], {
        authToken,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.dashboardGetDashboardProductPricingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.dashboardGetDashboardProductPricingSuccess(response.data));
    }
}
